<template>
    <div v-select-text="value" style="width: 600px; background-color: #fff; margin:0 auto; position: relative; border: 3px solid brown; padding: 20px;">
        <div style="font-weight: bold; font-size: 32px; line-height: 30px;">Исследование показало, чем <br>женщины-водители лучше <br>мужчин</div>
        <br>
        <img width="100%" src="./i1.png"/>
        <br>
        <img width="100%" src="./i2.png"/>
        <div style="height: 30px; font-size: 14px; color: #727272;">
            <span style="float: left;">© РИА Новости / Руслан Кривобок</span>
            <span style="float: right;">Перейти в фотобанк</span>
        </div>
        <br/>
        <div>
            <strong>Москва, 21 ноя — РИА Новости.</strong>
            Женщины менее склонны отвлекаться на что-то постороннее во время езды на автомобиле, чем мужчины, выяснили сотрудники Института транспортной экономики в Осло, изучившие привычки более 1,5 тысяч водителей.
            Результаты их работы опубликованы в журнале.
        </div>
    </div>
</template>

<script>
    import SelectText from '@/directives/select-text.js'

    export default {
        props: {
            value: [Array]
        },
        directives: {
            SelectText
        }
    }
</script>